<template>
    <tr :class="$style.receiptItem">
        <td>{{ label }}</td>
        <td><strong><slot></slot></strong></td>
    </tr>
</template>

<script>
    export default {
        name: "receipt-item-fragment",
        props : {
            label: { type: String, required: true }
        }
    }
</script>

<style module lang="scss">
    @import "../../style/abstract/abstract.functions.scss";
    @import "../../style/abstract/abstract.typography.scss";
    @import "../../style/abstract/abstract.spacing";

    .receiptItem {
      td {
        font-size: rem-calc(15);
        line-height: 1.25;
        font-family: $font-family;
        vertical-align: top;
        padding-bottom: $spacing-xs;

        &:last-child {
          text-align: right;
        }
      }
    }
</style>